import React from 'react';
import { Box } from '@mui/material';
import Tile from './Tile';
import { t } from 'i18next';
import TileNew from './TileNew';

const Gallery = ({ 
    images = [], 
    dialog, 
    listName = "",
    thumbnailOnClick = undefined,
    init = undefined,
    from = "", 
    isLink = false, 
    showRank = false, 
    shienLabelDisp = false, 
    startIndex = 0, 
    alignment = 'space-between',
    contentType = 'image' // 新しく追加
}) => {

    // レスポンシブな高さを設定
    const fixedHeight = { xs: 200, sm: 240, md: 280 };

    // コンテンツタイプに応じたアスペクト比の調整
    const getAspectRatio = (item, defaultAspect = 1) => {
        const itemContentType = item.content_type || item.type || contentType;
        
        switch(itemContentType) {
            case 'text':
            case 'document':
                return 0.75; // 4:3の縦長
            case 'event':
                return 1.5; // 3:2の横長
            case 'video':
                return item.aspect || 16/9; // 16:9がデフォルト
            case 'image':
            default:
                return item.aspect || defaultAspect;
        }
    };

    return (
        <Box sx={{ 
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            gap: { xs: 0.25, sm: 0.5 }, // モバイルでは小さなgap
            justifyContent: alignment === 'left' ? 'flex-start' : { xs: 'center', sm: 'space-between' }, // モバイルでは中央揃え
            alignItems: 'flex-start',
            margin: 0, // 外側のマージンを削除
            padding: { xs: '0 2px', sm: '0 4px' }, // モバイルでは小さなパディング
            width: '100vw', // ビューポートの100%幅を使用
            maxWidth: '100%', // 最大幅を100%に制限
            boxSizing: 'border-box', // ボーダーボックスモデルを適用
            zIndex: 501, // z-indexを設定
        }}>
            {images.map((image, i) => {
                i += startIndex
                if(image.isMute) return <span data-no={i} className="lazy" key={i}></span>

                // アスペクト比から幅を計算（コンテンツタイプに応じて調整）
                const aspect = getAspectRatio(image);
                const calculatedWidth = {
                    xs: fixedHeight.xs * aspect,
                    sm: fixedHeight.sm * aspect,
                    md: fixedHeight.md * aspect
                };
                
                // レスポンシブな最小・最大幅の設定（モバイル最適化）
                const minWidth = { xs: 120, sm: 150, md: 180 };  // ブレークポイントごとの最小幅
                
                // 左寄せの場合は固定幅、均等割りの場合は可変幅
                const maxWidth = alignment === 'left' ? {
                    xs: Math.max(minWidth.xs, calculatedWidth.xs),
                    sm: Math.max(minWidth.sm, calculatedWidth.sm),
                    md: Math.max(minWidth.md, calculatedWidth.md > 350 ? 350 : calculatedWidth.md),
                    lg: Math.max(minWidth.md, calculatedWidth.md > 400 ? 400 : calculatedWidth.md),
                } : {
                    xs: 'calc(50vw - 6px)', // モバイル：パディングとgapを考慮
                    sm: 'calc(33vw - 8px)', // タブレット：パディングとgapを考慮
                    md: calculatedWidth.md > 350 ? 350 : calculatedWidth.md, // デスクトップ：最大350px
                    lg: calculatedWidth.md > 400 ? 400 : calculatedWidth.md, // 大画面：最大400px
                };

                return (
                    <Box
                        key={i}
                        sx={{
                            width: alignment === 'left' ? {
                                xs: maxWidth.xs,
                                sm: maxWidth.sm,
                                md: maxWidth.md,
                                lg: maxWidth.lg,
                            } : {
                                xs: maxWidth.xs,
                                sm: maxWidth.sm, 
                                md: Math.max(minWidth.md, Math.min(calculatedWidth.md, maxWidth.md)),
                                lg: Math.max(minWidth.md, Math.min(calculatedWidth.md, maxWidth.lg)),
                            },
                            minWidth: alignment === 'left' ? {
                                xs: minWidth.xs,
                                sm: minWidth.sm,
                                md: minWidth.md,
                                lg: minWidth.md,
                            } : {
                                xs: 'auto',
                                md: minWidth.md
                            },
                            maxWidth: alignment === 'left' ? {
                                xs: maxWidth.xs,
                                sm: maxWidth.sm,
                                md: maxWidth.md,
                                lg: maxWidth.lg,
                            } : 'none',
                            flexShrink: alignment === 'left' ? 0 : 1,
                            flexGrow: alignment === 'left' ? 0 : 1,
                            margin: 0, // 外側マージンを削除
                            padding: 0, // 外側パディングを削除
                            boxSizing: 'border-box', // ボーダーボックスモデルを適用
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                height: fixedHeight,
                                position: 'relative',
                                borderRadius: { xs: 0.5, sm: 1 }, // モバイルでは小さい角丸
                                bgcolor: 'grey.100',
                                '& > *': {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                },
                            }}
                        >
                            <TileNew 
                                contentType={image.content_type || image.type || contentType}
                                data={image} 
                                i={i} 
                                dialog={dialog} 
                                key={image.id} 
                                list={images} 
                                listName={listName} 
                                rank={showRank ? i : undefined}
                                onClick={thumbnailOnClick !== undefined ? thumbnailOnClick : undefined} 
                                init={init} 
                                from={from} 
                                isLink={isLink} 
                                shienLabelDisp={shienLabelDisp}
                            />
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
};

export default Gallery;